import { ServiceProvider } from '../types';

export function getProviderName({ firstName, lastName, publicDisplayName }: ServiceProvider, def: string): string {
  if (!publicDisplayName && !(firstName && !lastName)) {
    return def;
  }
  return publicDisplayName || `${firstName} ${lastName}`;
}

export function sortByName(a: ServiceProvider, b: ServiceProvider) {
  if (a.lastName === b.lastName) {
    return a.firstName?.localeCompare(b.firstName);
  }
  return a.lastName?.localeCompare(b.lastName);
}
